import Swal from 'sweetalert2';

/** Matches WebKit/Firestore messages such as "Connection to Indexed Database server lost". */
const INDEXED_DB_LOST_PATTERN =
  /connection to indexed database server lost|indexed\s*database|indexeddb/i;
const SAFARI_LOAD_FAILED_PATTERN = /\bload failed\b/i;

let dialogShown = false;

function isIndexedDbConnectionError(reason: unknown): boolean {
  if (reason === null || reason === undefined) {
    return false;
  }
  const message =
    typeof reason === 'object' && reason !== null && 'message' in reason
      ? String((reason as { message?: unknown }).message)
      : String(reason);
  return INDEXED_DB_LOST_PATTERN.test(message);
}

function isSafariLoadFailedError(reason: unknown): boolean {
  if (reason === null || reason === undefined) {
    return false;
  }
  const message =
    typeof reason === 'object' && reason !== null && 'message' in reason
      ? String((reason as { message?: unknown }).message)
      : String(reason);
  return SAFARI_LOAD_FAILED_PATTERN.test(message);
}

/**
 * Mobile Safari (and iOS WebKit) can drop the IndexedDB connection after backgrounding or under memory pressure.
 * Firestore persistence surfaces this as an unhandled rejection. We show a single recoverable prompt.
 */
export function registerIndexedDbConnectionRecovery(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    if (!isIndexedDbConnectionError(event.reason) && !isSafariLoadFailedError(event.reason)) {
      return;
    }
    event.preventDefault();

    if (dialogShown) {
      return;
    }
    dialogShown = true;

    void Swal.fire({
      title: 'Connection lost',
      text: 'The browser storage connection was interrupted. Refresh the page to continue.',
      icon: 'warning',
      confirmButtonText: 'Refresh page',
      confirmButtonColor: '#1E3A5F',
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      } else {
        dialogShown = false;
      }
    });
  });
}
